export default __webpack_public_path__ + "static/media/0016.b8eac83d.png";